import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    gap: "12px",
    "@media (max-width: 480px)": {
      flexDirection: "column-reverse",
      "& > *": {
        width: "100%",
      },
    },
  },
}));

/**
 * Footer area for dialog actions (buttons). By default, items are right-aligned.
 * On small screens the buttons stack vertically in reverse order so the primary
 * action stays at the bottom (thumb-friendly).
 *
 * @param {string} className - Additional class name
 * @param {object} style     - Additional inline styles
 */
const DialogFooter = ({ className = "", style = {}, children, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={`${classes.footer} ${className}`} style={style} {...rest}>
      {children}
    </div>
  );
};

export default DialogFooter;
